import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { LAMBDA_BASE_URL } from "../../constants";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";

const Unsubscribe: React.FC = () => {
  const [searchParams] = useSearchParams();
  const unsubscribeEmail = searchParams.get("email");

  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationFn: (unsubscribeEmail: string) =>
      axios.post(LAMBDA_BASE_URL, { unsubscribeEmail }),
  });

  return unsubscribeEmail ? (
    <Card elevation={5} sx={{ width: 500, margin: "auto" }}>
      <CardContent>
        <Container maxWidth='sm' sx={{ mt: 8 }}>
          <Typography variant='h5' gutterBottom>
            🚫 Turn off automatic email syncing?
          </Typography>
          <Typography variant='body2' sx={{ mt: 2 }}>
            You can disable syncing at any time. Jarvis will stop accessing your
            inbox and will no longer add emails to Zoho CRM.
          </Typography>
          <Typography variant='body2' sx={{ mt: 1 }}>
            This won’t affect manual forwarding or CC-based flows — only the
            automatic syncing will stop.
          </Typography>
          <Button
            variant='outlined'
            color='error'
            sx={{ mt: 4 }}
            onClick={() => mutate(unsubscribeEmail)}>
            🔕 Disable Automatic Syncing
            {isPending && (
              <Box
                sx={{
                  ml: "8px",
                }}>
                <CircularProgress />
              </Box>
            )}
          </Button>
          {isSuccess && (
            <Typography variant='body1' color='success.main' mt='8px'>
              ✅ Automatic syncing has been successfully disabled.
            </Typography>
          )}
          {isError && (
            <Typography variant='body1' color='error' mt='8px'>
              ❌ An error occurred while disabling automatic syncing. Please try
              again later.
            </Typography>
          )}
        </Container>
      </CardContent>
    </Card>
  ) : (
    <h1>No unsubscribe email provided</h1>
  );
};

export default Unsubscribe;
